import React, { useState } from "react";
import { IoMdSearch } from "react-icons/io";
import { IoInformationCircleOutline } from "react-icons/io5";
import { MdOutlineFamilyRestroom } from "react-icons/md";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Dialog,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Tooltip,
  Typography,
} from "../../ppui";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { Snackbar } from "../../ppui/snackbar";
import { logger } from "../../utils/logger";
import { ContentBody, ContentHeading, ContentLayout } from "../style";
import {  TbInfoTriangle } from "react-icons/tb";
import { SelectFieldMulti } from "../../ppui/select-field-multi";

function Element() {
  const handleChange = (newChecked) => {
    alert(`Switch is now: ${newChecked}`);
  };

  const options = [
    { id: "true", name: "Banana-Banana" },
    { id: "false", name: "Orange-Orange" },
    { id: "grape", name: "Grape" },
    { id: "mango", name: "Mango" },
    { id: "kiwi", name: "Exotic Green Kiwi Fruit" },
    { id: "ape", name: "AppleApple" },
    { id: "pear", name: "Juicy Williams Pear" },
    { id: "peach", name: "Sweet and Succulent Peach" },
    { id: "plum", name: "Plump Red Plum Fruit" },
    { id: "watermelon", name: "Refreshing Red Watermelon Slice" },
    { id: "pineapple", name: "Tropical Golden Pineapple" },
    { id: "strawberry", name: "Delicious Fresh Strawberry" },
    { id: "blueberry", name: "Nutritious Blueberry Bunch" },
    { id: "blackberry", name: "Rich Dark Blackberry Fruit" },
    { id: "apricot", name: "Ripe Apricot Delight" },
    { id: "cantaloupe", name: "Sweet Cantaloupe Melon" },
  ];
  const [selectValues, setSelectValues] = useState("kiwi");
  const [selectedValues, setSelectedValues] = useState();


  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const [isDisabled, setIsDisabled] = useState(false);

  const handleClickDisable = () => {
    setIsDisabled(!isDisabled); // Toggle disabled state
  };
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  const snackbarClose = () => {
    setSnackbarVisible(false);
  };
  const snackbarOpen = () => {
    setSnackbarVisible(true);
  };
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography
            variant="h5"
            mb="0"
            color="secondary"
            lableLFirst
            lableBold
          >
            Employee List
          </Typography>
        </ContentHeading>

        <ContentBody>
        <Button onClick={snackbarOpen}>Show Snackbar</Button>

        <Snackbar
          message="This is a snackbar message!"
          color="danger"
          variant="contained"
          size="medium"
          position="top-right"
          onClose={snackbarClose}
          onOpen={snackbarVisible}
          loading={false}
          duration={10000}
          clearable
          icon={<TbInfoTriangle />}
        />
        <br />
        <SelectFieldMulti
  label="Select Items"
  multiSelect={true}
  searchable={true}
  clearable={true}
  options={[
    { id: "1", name: "Option 1" },
    { id: "2", name: "Option 2" },
    { id: "3", name: "Option 3", disabled: true },
    { id: "4", name: "Option 4" },
  ]}
  defaultValue={["1", "4"]}
  onChange={(selected) => logger.log("Selected:", selected)}
/>
          <br />
          <SelectField
            label="Select an Option"
            required
            options={options}
            placeholder="Select One"
            clearable
            onChange={(value)=>{
              setSelectedValues(value)
              
            }}
          />

<SelectField
            label="Select an Option"
            required
            options={options}
            placeholder="Select One"
            clearable
            onChange={(value)=>{
              setSelectedValues(value)
              
            }}
            searchable
          />
          <br />


<SelectField
            label="Select an Option"
            required
            options={options}
            placeholder="Select One"
            clearable
            onChange={(value)=>{
              setSelectedValues(value)
              logger.log(value)
            }}
            multiple
          />
          <br />

          <div>
        <strong>Selected Value: {selectedValues}</strong>  | 
        <strong>Selected Value: {selectedValues}</strong> 
       
      </div>
          <br />
          <SelectField
            label="Select an Option"
            required
            placeholder="select one"
            options={options}
            multiSelect
            defaultValue={selectValues}
          />
          <br />


        <Button
          color="primary"
          variant="contained"
          loading
        >
          Loading Button
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleClickDisable}
          disabled={isDisabled} 
          loading ={isDisabled} 
        >
          {isDisabled ? 'Disabled' : 'Click to Disable and Loading'}
        </Button>
        <Button
          color="primary"
          onClick={handleClickOpen}
          variant="outlined"
        >
          Open Dialog
        </Button>

        <Dialog
          title="Dialogue Title"
          closeButton={true}
          fullWidth
          maxWidth="xxl"
          open={open}
          onClose={handleClose}
          onSubmit={() => alert("Submitted")}
          bgClose
          separator
          bodyScroll={true}
          actionAllign="right"
          buttonName={"Custom name"}
          btnLoading
          footer={
          <>
          <Switchbox
            label="Example Checkbox"
            color="success"
            size="lg"
            lableBold
            checked={false} // or false based on your initial state
            onChange={handleChange}
          />
          <Button variant="text" onClick={() => alert("Custom Action")}>Custom Footer Action</Button>,
  </>
        }
        >
        </Dialog>

          <Switchbox
            label="Example Checkbox"
            color="success"
            size="lg"
            lableBold
            checked={true} // or false based on your initial state
            onChange={handleChange}
          />
          <br />
          ~~~~~~~~~~~~~~~~~~~~~
          <Checkbox
            label="I agree to the terms and conditions" // The label displayed next to the checkbox
            checked={true} // Pass the state to manage the checked state
            error={false} // Optionally show an error state
            color="primary" // Define the checkbox color (uses the `primary` color from theme)
          />
          <Checkbox
            label="I agree to the terms and conditions" // The label displayed next to the checkbox
          />
          <br />
          <br />
          ~~~~~~~~~~~~~~~~~~~~~
          <Row>
            <Col sm={4}>column 4 I agree to the terms and conditions</Col>
            <Col sm={"auto"}>
              column auto I agree to the terms and conditions
            </Col>
            <Col>column restof width I agree to the terms and conditions</Col>
          </Row>
          ~~~~~~~~~~~~~~~~~~~~~ outlined
          <br />
          <div style={{ padding: "50px" }}>
            <Tooltip
              title="This is an info icon"
              position="top"
              size="md"
              color={"primary"}
            >
              <IoInformationCircleOutline
                style={{ fontSize: "24px", cursor: "pointer" }}
              />
            </Tooltip>

            <Tooltip
              title="This button is disabled"
              position="bottom"
              color="success"
            >
              <button
                style={{
                  padding: "10px 20px",
                  marginLeft: "20px",
                  cursor: "not-allowed",
                }}
                disabled
              >
                Disabled Button
              </button>
            </Tooltip>
          </div>
          ~~~~~~~~~~~~~~~~~~~~~
          <InputField
            variant="outlined"
            color="secondary"
            placeholder="Outlined No label Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="outlined"
            color="secondary"
            size="sm"
            label="Outlined sm Size Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="outlined"
            label="Outlined  Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="outlined"
            color="secondary"
            size="lg"
            label="Outlined lg Size Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          standard
          <br />
          ~~~~~~~~~~~~~~~~~~~~~
          <InputField
            variant="standard"
            color="secondary"
            placeholder="Standard No label Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="standard"
            label="standard  sm Size Input"
            size="sm"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="standard"
            label="standard Input"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          <InputField
            variant="standard"
            label="standard lg Size Input"
            size="lg"
            prefix={<IoMdSearch />}
          />
          <br />
          <br />
          filled
          <br />
          ~~~~~~~~~~~~~~~~~~~~~
          <InputField variant="filled" />
          <br />
          <br />
          <InputField variant="filled" label="filled sm Size Input" size="sm" />
          <br />
          <br />
          <InputField variant="filled" label="filled Input" />
          <br />
          <br />
          <InputField variant="filled" label="filled lg Size Input" size="lg" />
          <br />
          <br />
          <SelectField
            label="Select an Option"
            required
            options={options}
            placeholder="select one"
            defaultValue={selectValues}
            onChange={setSelectValues}
            valueSinc
          />
          <br />
          <br />
          <SelectField
            label="Select an Option"
            required
            placeholder="select one"
            options={options}
          />
          <br />
          <br />
          <SelectField
            label="Select an Option"
            required
            placeholder="select one"
            multiple
            options={options}
          />
          <br />
          <br />
          <div style={{ width: "300px" }}>
            <SelectField
              label="Fruits"
              placeholder="Select fruits"
              options={options}
              multiple // Enable multiple selection
              searchable
              fullWidth
            />
          </div>
          <br />
          <SelectField
            label="Choose an option"
            required={true} // Show required star (*)
            placeholder="Select..." // Placeholder for the input
            options={options}
            searchable // Handle the change in selection
            size="lg" // Dropdown size (sm, md, lg)
            fullWidth={true} // Set full width of input field
            color="secondary" // Color theme (use your theme color)
            variant="outlined" // Variant (outlined or standard)
            helperText="Please select an option" // Helper text

          />
        </ContentBody>
        <br />
        <br />
        <br />
        <List size={"md"} color={"danger"}>
          <ListItem>
            <Avatar shape="circle" initials="AS" size={"sm"}></Avatar>
            <ListText primary="pankaj Saha" secondary="#ecr43" />
            <ListIcon>
              <MdOutlineFamilyRestroom />
            </ListIcon>
          </ListItem>
        </List>
        <List
          size="md"
          color="secondary"
          hover="secondary"
          gap="1rem"
          separator
        >
          <ListItem>
            <ListIcon>📎</ListIcon>
            <ListText primary="Item 1" secondary="Description 1" />
          </ListItem>
          <ListItem onClick={() => alert("Item 2 clicked")}>
            <ListIcon>✅</ListIcon>
            <ListText primary="Item 2" secondary="Description 2" />
          </ListItem>
          <ListItem>
            <ListIcon>⚙️</ListIcon>
            <ListText primary="Item 3" />
          </ListItem>
        </List>
      </ContentLayout>
    </>
  );
}

export default Element;
